module.exports = __webpack_public_path__ + "img/Walmart.b9781b18.svg";